import React, { useState, useEffect, useCallback } from 'react';

import type { ModalInstance } from '../lib/serviceModal';
import { modalService } from '../lib/serviceModal';

export const GlobalDialog = () => {
  const [modals, setModals] = useState<ModalInstance[]>([]);

  useEffect(() => {
    modalService.registerUpdateCallback(() => {
      setModals([...modalService.getModals()]);
    });
  }, []);

  const handleClose = useCallback((modalId: string, result?: any) => {
    modalService.close(modalId, result);
  }, []);

  const handleOverlayClick = useCallback((modalId: string, event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      modalService.close(modalId, null);
    }
  }, []);

  return (
    <>
      {modals.map((modal) => {
        const ModalComponent = modal.component;
        return (
          <ModalComponent
            visible={modal.visible}
            key={modal.id}
            data={modal.props}
            onOverlayClick={(result?: any) => handleOverlayClick(modal.id, result)}
            onClose={(result?: any) => handleClose(modal.id, result)}
          />
        );
      })}
    </>
  );
};
